/** H5 floating CTA shell — viewport-bottom pin (inactive from md / 960px) */
export const ONBOARDING_FLOATING_CTA_SHELL_CLASS =
  "max-md:absolute max-md:bottom-0 max-md:inset-x-0 max-md:z-20";

/** H5 bottom spacing: 16px + safe-area inset */
export const ONBOARDING_FLOATING_CTA_BOTTOM_CLASS =
  "max-md:pb-[calc(16px+env(safe-area-inset-bottom,0px))]";

/** Value prop — viewport width minus 48px (24px each side) */
export const ONBOARDING_FLOATING_CTA_INSET_WIDE_CLASS = "max-md:px-6";

/** Quiz Continue — viewport width minus 32px (16px each side) */
export const ONBOARDING_FLOATING_CTA_INSET_NARROW_CLASS = "max-md:px-4";

/** H5 scroll reserve: 48px button + 16px + safe-area */
export const ONBOARDING_FLOATING_CTA_CONTENT_RESERVE_CLASS =
  "max-md:pb-[calc(64px+16px+env(safe-area-inset-bottom,0px))]";

export const ONBOARDING_FLOATING_CTA_PC_BASE_CLASS = "md:relative md:shrink-0";

/** Value prop PC — Figma 96344:110167: exact 460px column, 72px margin above CTA */
export const ONBOARDING_FLOATING_CTA_PC_WIDE_CLASS =
  "md:mx-auto md:w-[460px] md:max-w-[460px] md:px-0 md:mt-[72px]";

/** Quiz PC — Figma Name/Numeric Desktop: input/slider bottom → Continue = 134px */
export const ONBOARDING_QUIZ_PC_INPUT_TO_CTA_GAP_CLASS = "md:mt-[134px]";

export const ONBOARDING_FLOATING_CTA_PC_NARROW_CLASS =
  "md:mx-auto md:w-full md:max-w-[460px] md:px-0 md:mt-[134px]";
